var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rest-page',{staticClass:"page-ct",attrs:{"fetch-endpoint":_vm.fetchEndpoint}},[_c('page-header-new',{attrs:{"title":_vm.gameName,"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('game-frame',{attrs:{"project-id":_vm.projectId,"domain":_vm.domain,"token":_vm.token}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da0e9b6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/gamification/pages/GameDashboardPage.vue
// module id = null
// module chunks = 